export const SURVEY_LIST_PAGE_SIZE = 100;
